<template>
  <div :class="{isFull: item.detail.type === 'fcu' && (item.detail.control === 'temp' || item.detail.control === 'speed')}"
    :data-extra="item.extra ? item.index : null">
    <div class="ctrlModule" :class="{fcuPower: item.status && item.status.power === 1}">
      <!-- fcu:: fanspeed -->
      <div v-if="item.detail.type === 'fcu' && item.detail.control === 'speed'" class="detail">
        <div class="fanSpeed"
           :class="{isAuto: item.status && item.status.power === 1 && item.status.manual === 0}">
          <div class="speed">
            <div class="fan"><img src="@/assets/img/ico_fan.png" alt=""></div>
            <span v-for="bar in 3" :key="bar" class="bar" :class="{active: item.status && item.status.speed >= bar}"></span>
          </div>
          <div class="btns notranslate">
            <button type="button" class="btnMinus" @click="fcuSpeed('minus')">-</button>
            <button type="button" class="btnPlus" @click="fcuSpeed('plus')">+</button>
            <button type="button" @click="fcuSpeed('stop')">STOP</button>
            <button type="button" class="btnAuto" @click="fcuSpeed('auto')" :style="{backgroundColor: item.status && item.status.power === 1 && item.status.manual === 0 && pointColors && pointColors.color}">AUTO</button>
          </div>
        </div>
      </div>
      <!-- //fcu:: fanspeed -->
      <!-- fcu:: temp -->
      <div v-else-if="item.detail.type === 'fcu' && item.detail.control === 'temp'" class="detail">
        <div class="temp notranslate">
          <span class="current">{{item.status ? item.status.curtemp : '25.0'}}</span>/<span class="set" @click="setTempLayer">{{item.status ? item.status.usertemp : '25.0'}}</span>
          <div class="btns">
            <button type="button" @click="fcuTemp('up')">▲</button>
            <button type="button" @click="fcuTemp('down')">▼</button>
          </div>
        </div>
        <div v-show="tempInfo.active" class="tempList layer">
          <button type="button" class="btnClose" @click.stop="tempInfo.active = false"><span class="blind">close</span></button>
          <div class="inner notranslate" ref="tempLayer">
            <ul>
              <li v-for="temp in tempList" :key="temp"
                :id="`offset_${item.id}_${temp}`"
                :class="{active: temp === (item.status ? item.status.usertemp : '25.0')}">
                <div class="checkbox radio">
                  <input type="radio"
                    :id="`temp_${item.id}_${temp}`"
                    :name="`temp_${item.id}`"
                    :value="temp"
                    :checked="temp === (item.status ? item.status.usertemp : '25.0')"
                    @change="selectTemp(temp)">
                  <label :for="`temp_${item.id}_${temp}`">
                    {{temp}}
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- //fcu:: temp -->
      <div v-if="item.detail.control === 'toggle'" class="detail">
        <div class="icon"><img :src="icon(item.detail)" alt="" /></div>
        <div class="label">{{item.label[lang]}}</div>
        <div v-if="item.type === 'curtain'" class="btnControl notranslate">
          <button type="button" class="btnCurtain" @click="toggle('open')">OPEN</button>
          <button type="button" class="btnCurtain" @click="toggle('close')">CLOSE</button>
          <button v-if="item.detail.stop" type="button" class="btnCurtain" @click="toggle('stop')">STOP</button>
        </div>
        <div v-else-if="item.type === 'door'" class="btnControl notranslate">
          <button type="button" class="btnCurtain" @click="toggle(1)">OPEN</button>
        </div>
        <div v-else class="btnControl">
          <button
            type="button"
            class="toggle"
            :class="{on: item.status === 1}"
            :style="item.status === 1 && pointColors"
            @click="toggle">
            <span class="circle" :style="item.status === 1 && pointColors && pointColors.color && {backgroundColor: pointColors.color}"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ControlItem',
  props: [
    'lang',
    'locale',
    'item'
  ],
  components: {
  },
  computed: {
    pointColors () {
      const setting = this.$store.state.common && this.$store.state.common.setting
      const pointColors = setting && setting.pointcolors
      const color = pointColors && pointColors.roomcontrolActivate
      const result = color ? {
        color: color,
        borderColor: transformAlpha(color, '0.1'),
        backgroundColor: transformAlpha(color, '0.2')
      } : null
      function transformAlpha (color, alpha) {
        color = color.match(/\d+/g)
        return `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${alpha})`
      }
      return result
    },
    isValidType () {
      return this.types.includes(this.item.type)
    },
    index () {
      return Number(this.item.index.replace(/[^0-9]/g, '')) - 1
    },
    tempList () {
      const min = Number(this.tempInfo.min) // 18
      const max = Number(this.tempInfo.max) // 28
      const index = (max - min) * 2 - 1 // 18.0, 18.5, 29.0, ...28.0
      let list = [min.toFixed(1)]
      let temp = min.toFixed(1)
      for (let i = 0; i <= index; i++) {
        temp = Number(temp) + 0.5
        list.push(temp.toFixed(1))
      }
      return list
    }
  },
  data () {
    let tempMin = (this.item && this.item.detail && this.item.detail.tempMin) || 18
    let tempMax = (this.item && this.item.detail && this.item.detail.tempMax) || 28
    return {
      types: [
        'light',
        'fcu',
        'dm',
        'curtain',
        'door'
      ],
      fanspeed: [
        'stop',
        'low',
        'mid',
        'high',
        'auto'
      ],
      tempInfo: {
        active: false,
        min: tempMin,
        max: tempMax
      }
    }
  },
  methods: {
    icon (detail) {
      const isValidType = this.isValidType
      const src = isValidType ? detail.icon : 'default'
      const icon = require(`@/assets/img/roomcontroller/ico_${src}.png`)
      return icon
    },
    getIndex (index) {
      const idx = Number(index.replace(/[^0-9]/g, ''))
      return (idx - 1).toString()
    },
    fcuSpeed (spd) {
      const index = getIndex(this.item.index)
      const currentSpeed = this.item.status.speed
      const speed = this.fanspeed
      const data = {
        item: 'fcuSpeed',
        param1: index,
        param2: getSpeed(spd)
      }
      function getIndex (index) {
        const idx = Number(index.replace(/[^0-9]/g, ''))
        return (idx - 1).toString()
      }
      function getSpeed (spd) {
        if (spd === 'auto' || spd === 'stop') {
          return spd
        } else {
          if (spd === 'plus') {
            const index = currentSpeed >= 3 ? 3 : currentSpeed + 1
            return speed[index]
          } else if (spd === 'minus') {
            const index = currentSpeed <= 1 ? 1 : currentSpeed - 1
            return speed[index]
          }
        }
      }
      this.$emit('setRcu', data)
    },
    fcuTemp (upDown) {
      const index = this.getIndex(this.item.index)
      const userTemp = Number(this.item.status.usertemp)
      const temp = upDown === 'up' ? userTemp + 0.5 : userTemp - 0.5
      const data = {
        item: 'temp',
        param1: index,
        param2: temp.toFixed(1).toString()
      }
      this.$emit('setRcu', data)
    },
    setTempLayer () {
      this.tempInfo.active = true
      setTimeout(() => {
        const layer = this.$refs.tempLayer
        const layerHeight = layer.offsetHeight
        const half = layerHeight / 1.8
        const status = this.item.status ? this.item.status.usertemp : '25.0'
        const temp = `offset_${this.item.id}_${status}`
        const activeTop = document.getElementById(temp).offsetTop
        let scrollTop = 0
        if (activeTop > half) {
          scrollTop = activeTop - half
        }
        this.$refs.tempLayer.scrollTop = scrollTop
      }, 100)
    },
    selectTemp (temp) {
      const data = {
        item: 'temp',
        param1: this.getIndex(this.item.index),
        param2: temp
      }
      this.$emit('setRcu', data)
      this.tempInfo.active = false
    },
    toggle (status) {
      const itemStatus = this.item.type === 'curtain' ? status : null
      const data = getItemData(this.item, itemStatus)
      function getIndex (index) {
        const idx = Number(index.replace(/[^0-9]/g, ''))
        return idx >= 1 ? (idx - 1).toString() : '0'
      }
      function getItemData (item, status) {
        let params = {}
        const toggle = item.type === 'curtain'
          ? status
          : item.status === 1
            ? 'off'
            : 'on'
        // case:: light
        if (item.type === 'light') {
          params.item = item.type
          if (item.index === 'all') {
            params.item = `${item.type}All`
            params.param1 = toggle
          } else if (item.index === 'multi') {
            params.item = `${item.type}Multi`
            params.param1 = item.multi.map(x => {
              const index = getIndex(x)
              return {
                [index]: item.status === 1 ? 'off' : item.multiOnoff.includes(x) ? 'on' : 'off'
              }
            })
          } else {
            params.param1 = getIndex(item.index)
            params.param2 = toggle
          }
        // case:: fcu
        } else if (item.type === 'fcu') {
          if (item.detail.control === 'toggle') {
            if (item.index === 'all') {
              params.item = 'fcuPowerAll'
              params.param1 = toggle
            } else { // fcu는 멀티 없음
              params.item = 'fcuPower'
              params.param1 = getIndex(item.index)
              params.param2 = toggle
            }
          }
        // case:: curtain
        } else if (item.type === 'curtain') {
          if (item.detail.control === 'toggle') {
            if (item.index === 'all') {
              params.item = 'curtainAll'
              params.param1 = toggle
            } else if (item.index === 'multi') {
              params.item = 'curtainMulti'
              params.param1 = item.multi.map(x => {
                const index = `${getIndex(x)}` // 커튼멀티는 인덱스
                return {
                  // [index]: item.multiOnoff.includes(x) ? 'open' : 'close'
                  [index]: toggle
                }
              })
            } else {
              params.item = item.type
              params.param1 = `s${getIndex(item.index)}` // 커튼개별은 s${index}
              params.param2 = toggle
            }
          }
        // case:: door
        } else if (item.type === 'door') {
          params.item = item.index
          params.param1 = getIndex(item.index)
          params.param2 = toggle
        } else {
          params.item = item.index
          params.param1 = getIndex(item.index)
        }
        return params
      }
      this.$emit('setRcu', data)
    }
  }
}
</script>
